import { globalStyle, style } from '@vanilla-extract/css';

export const text = style({});

export const styledLeaf = style({
  color: 'var(--color)',
  textTransform: 'var(--text-transform)',

  selectors: {
    '&:hover': {
      color: 'var(--text-color-hover, var(--color))',
      textDecorationColor: 'var(--text-decoration-color-hover)',
      textDecorationLine: 'var(--text-decoration-hover)',
    },
  },
});

globalStyle(`${text}:not(:empty), ${text} span:not(:empty)`, {
  fontSize: 'var(--font-size, inherit)',
  lineHeight: 'var(--line-height, inherit)',

  '@media': {
    'only screen and (--mobile)': {
      fontSize: 'var(--mobile-font-size, inherit)',
      lineHeight: 'var(--mobile-line-height, inherit)',
    },
  },
});

globalStyle(`${text}:empty::after ,${text} span:empty::after`, {
  content: '\\FEFF' /* to keep height of the element constant */,
});

globalStyle(`${text} code`, {
  backgroundColor: 'var(--background-highlight)',
  color: 'var(--text-light)',
  padding: '0.25em 0.5em',
  fontSize: '0.875em',
});

globalStyle(`${text} em`, {
  paddingRight: '0.15em',
});
